"use client";

import type { WaveformRenderingStrategy } from "@components/composers/waveform/WaveformComplex";
import type { WaveformTwoStepColor } from "@components/composers/waveform/types";

import WaveformComplex from "@components/composers/waveform/WaveformComplex";
import { cn } from "@ui/lib/utils";
import { memo } from "react";

interface HeroWaveformProps {
  className?: string;
  color?: WaveformTwoStepColor;
  mobileStrategy?: WaveformRenderingStrategy;
  speed?: "normal" | "slow";
  waveformClassName?: string;
}

/**
 * Isolated client component for hero waveforms.
 * This component is memoized to prevent unnecessary rerenders when parent components
 * or sibling components (like omnibox) trigger updates via server actions.
 */
function HeroWaveformInner({ className, color, mobileStrategy, speed, waveformClassName }: HeroWaveformProps) {
  return (
    <div className={cn(className)}>
      <WaveformComplex className={waveformClassName} color={color} mobileStrategy={mobileStrategy} speed={speed} />
    </div>
  );
}

// Memoize with a custom comparison function to prevent rerenders
// unless the actual props change
export const HeroWaveform = memo(HeroWaveformInner, (prevProps, nextProps) => {
  return (
    prevProps.className === nextProps.className &&
    prevProps.color === nextProps.color &&
    prevProps.mobileStrategy === nextProps.mobileStrategy &&
    prevProps.speed === nextProps.speed &&
    prevProps.waveformClassName === nextProps.waveformClassName
  );
});

HeroWaveform.displayName = "HeroWaveform";
